<template>
  <div class="workOrder">
    <div class="workOrder_top">
      <div class="workOrder_top_content">
        <div class="workOrder_top_box">
          <van-tabs
            v-model="active"
            @change="tabsChange"
            class="workOrder_top_box_tab"
            color="#4ABEF8"
          >
            <van-tab title="需求池"></van-tab>
            <van-tab title="工单"></van-tab>
          </van-tabs>
        </div>
        <!-- 需求池 -->
        <template v-if="active == 0">
          <van-list
            v-model="loading"
            :finished="finished"
            offset="20"
            :immediate-check="false"
            @load="onLoad"
            finished-text="没有更多了 ~"
            v-if="demandList.length > 0"
          >
            <div
              class="workOrder_top_content_box"
              v-for="(item, index) in demandList"
              :key="index"
              @click="goDetails(item)"
            >
              <div :class="item.class">
                <div>
                  <i class="el-icon-date workOrder_top_content_box_top_i"></i>
                  <span class="workOrder_top_content_box_top_span1">{{
                    item.createTime
                  }}</span>
                </div>
                <span class="workOrder_top_content_box_top_span">
                  <span v-if="item.status == 1">待评审</span>
                  <span v-if="item.status == 2">通过</span>
                  <span v-if="item.status == 3">驳回</span>
                  <span v-if="item.status == 4">已转为工单</span>
                </span>
              </div>
              <div class="workOrder_top_content_box_content">
                <div class="workOrder_top_content_box_content_title">
                  <span>{{ item.title }}</span>
                </div>
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="提出人："
                  :value="item.userName"
                />
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="工单类型："
                  :value="item.type == 1 ? '内部' : '外部'"
                />
                <van-cell
                  :border="false"
                  v-if="item.incomeType != 3"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="奖金："
                  :value="item.money ? item.money : item.incomeRemark"
                />
                <van-cell
                  :border="false"
                  v-else
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="奖金："
                  value="无"
                />
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  title="紧急程度："
                  value-class="cell_value"
                >
                  <template #default>
                    <div class="time colorBoxBig">
                      <span
                        class="colorBox"
                        v-if="item.level == 1"
                        style="background: #f56c6c"
                      ></span>
                      <span
                        class="colorBox"
                        v-if="item.level == 2"
                        style="background: #e6a23c"
                      ></span>
                      <span
                        class="colorBox"
                        v-if="item.level == 3"
                        style="background: #409eff"
                      ></span>
                    </div>
                  </template>
                </van-cell>
              </div>
              <div class="btnBox" v-if="notAuthorized == 1">
                
                <van-button type="info" round size="small"  plain @click.stop="goAddPage(item.id)"
                  v-if="item.status == 1">修 改</van-button>
                  <template v-if="isExamine == 1">
                <van-button type="info" size="small"  round   @click.stop="handleAudit(item)"
                  v-if="item.status == 1">评 审</van-button>
                <van-button type="info" size="small"  round  @click.stop="goAddConvert(item.id)"
                  v-if="item.status == 2">转为工单</van-button>
                  </template>
                <van-button type="info"  size="small"  round  @click.stop="goAddPage(item.id)"
                  v-if="item.status ==1 ">重新提交</van-button>
              </div>
            </div>
          </van-list>
          <van-empty description="暂无数据" v-if="demandList.length == 0" />
        </template>
        <!-- 工单 -->
        <template v-if="active == 1">
          <div class="mycheckbox">
            <el-checkbox
              v-model="isMine"
              @change="mineChange()"
              v-if="authType == 2"
              >我的</el-checkbox
            >
          </div>
          <van-list
            v-model="loading"
            :finished="orderfinished"
            offset="20"
            :immediate-check="false"
            @load="onLoad"
            finished-text="没有更多了 ~"
            v-if="orderList.length > 0"
          >
            <div
              class="workOrder_top_content_box"
              v-for="(item, index) in orderList"
              :key="index"
              @click="goTickets(item)"
            >
              <div :class="item.class">
                <div>
                  <i class="el-icon-date workOrder_top_content_box_top_i"></i>
                  <span class="workOrder_top_content_box_top_span1">{{
                    item.createTime
                  }}</span>
                </div>
                <span class="workOrder_top_content_box_top_span">
                  <span v-if="item.status == 1">进行中</span>
                  <span v-if="item.status == 2">已完成</span>
                  <span v-if="item.status == 3">已交付</span>
                  <span v-if="item.status == 4">延期</span>
                  <span v-if="item.status == 5">待评审</span>
                  <span v-if="item.status == 6">待开始</span>
                </span>
              </div>
              <div class="workOrder_top_content_box_content">
                <div class="workOrder_top_content_box_content_title">
                  <span>{{ item.title }}</span>
                </div>
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="负责人："
                  :value="item.userName"
                />
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="计划开始时间："
                  :value="item.planStartTime"
                />
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  value-class="cell_value"
                  title="计划结束时间："
                  :value="item.platEndTime"
                />
                <van-cell
                  :border="false"
                  title-class="workOrder_top_content_box_content_cell_title"
                  v-if="item.extensionMessage"
                  value-class="cell_value"
                  title="延期原因："
                  :value="item.extensionMessage"
                />
              </div>
              <div class="btnBox" v-if="notAuthorized == 1">
                <van-button
                  type="default"
                  size="small"
                  round
                  @click.stop="workAddOrder(item)"
                  >新增子工单</van-button
                >
                <van-button
                  type="info"
                  round
                  v-if="item.status == 1"
                  size="small"
                  @click.stop="handlePostpone(item)"
                  >延期</van-button
                >
                <van-button
                  type="info"
                  round
                  v-if="item.status == 6"
                  size="small"
                  @click.stop="upStatusFun(item)"
                  >开始</van-button
                >
                 <template v-if="isExamine == 1">
                <van-button type="info" round v-if="item.status == 3" size="small"
                  @click.stop="handleReview(item)">评审</van-button>
                  </template>
                   <van-button type="info" round v-if="item.status != 3 && item.status != 2" size="small"
                  @click.stop="handleUpdate(item)">修改</van-button>
              </div>
            </div>
          </van-list>
          <van-empty description="暂无数据" v-if="orderList.length == 0" />
        </template>
      </div>
    </div>
    <el-dialog
      title="提示：请输入联系电话"
      :visible.sync="dialogVisible"
      width="80%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :top="'33vh'"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="0px">
        <el-form-item prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入联系电话"
            maxlength="11"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPhoneForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="auditShow"
      width="90%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :top="'33vh'"
    >
      <el-form
        ref="auditForm"
        :model="auditForm"
        :rules="auditRules"
        label-width="120px"
      >
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="预计开始时间"
          prop="startTime"
          v-if="auditForm.status == 2"
        >
          <el-date-picker
          style="width:200px"
            clearable
            v-model="auditForm.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择预计开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="驳回原因"
          prop="rejectMessage"
          v-if="auditForm.status == 3"
        >
          <el-input
            v-model="auditForm.rejectMessage"
            placeholder="请输入驳回原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="auditShow = false">取 消</el-button>
        <el-button type="primary" @click="submitauditForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="80%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :top="'40vh'"
    >
      <span style="display: inline-block; width: 100%; text-align: center"
        >你没有权限查看项目管理</span
      >
    </el-dialog>
    <!-- 添加或修改工单基本信息对话框 -->
    <workOrderPop ref="workOrderPop" @ok="getDemand(1)" />
    <div class="backTop" @click="goAddPage('null')" v-if="active == 0">
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import {
  listDemand,
  getRoleByPhone,
  listOrder,
  updateOrder,
  listPersonnel,
  getOrder,
  getInfo,
  updateDemand,
  listDemandNo,
  listOrderByPhone,
} from "@/api/workOrder";
import { Dialog } from "vant";
import Cookies from "js-cookie";
import workOrderPop from "@/views/signIn/workOrderPop";
export default {
  name: "workOrder",
  components: { workOrderPop },
  data() {
    return {
      active: 0,
      loading: false,
      finished: false, //数据完全加载结束为 true
      orderfinished: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: this.$route.params.userId,
        phone: this.$route.params.phone,
        companyId: this.$route.params.companyId,
      },
      demandList: [],
      dialogVisible: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      authType: 2,
      centerDialogVisible: false,
      orderList: [],
      notAuthorized: 0,
      isMine: true,
      auditShow: false,
      auditForm: {},
      auditRules: {
         status: [
          { required: true, message: "审核状态不能为空", trigger: "blur" },
        ],
      },
      isExamine: 0
    };
  },
  mounted() {
    // console.log(this.$route.params)companyId,userId
    if (this.$route.params.phone) {
      this.getAllDemand();
      this.getUserFun();
      this.dialogVisible = false;
      Cookies.set("notAuthorized", 1, { expires: 30 });
      this.notAuthorized = 1;
      this.isExamine = this.$route.params.isExamine
      Cookies.set("isExamine", this.$route.params.isExamine, { expires: 30 });
    } else {
        this.isExamine = 0
      Cookies.set("isExamine", 0, { expires: 30 });
      Cookies.set("notAuthorized", 2, { expires: 30 });
      this.notAuthorized = 2;
      if (Cookies.get("externalPhone")) {
        this.form.phone = Cookies.get("externalPhone");
        this.submitPhoneForm();
      } else {
        this.dialogVisible = true;
      }
    }
  },
  methods: {
    delHtmlTag(str) {
      if (!str) {
        return;
      }
      str = str.replace(/<([a-z]+?)[^>]*>/g, "");
      return str.replace(/<\/([a-z]+?)+>/g, ""); // 去掉所有的html标记
    },
    escape2Html(str) {
      if (!str) {
        return;
      }
      return str.replace(/&+[a-zA-Z]+;/g, "");
    },
    getUserFun() {
      getInfo({
        companyId: this.$route.params.companyId,
        id: this.$route.params.userId,
      }).then((response) => {
        let rows = response.data;
        console.log(rows);
        Cookies.set("userId", rows.id, { expires: 30 });
        Cookies.set("NickName", rows.name, { expires: 30 });
        Cookies.set("companyId", this.$route.params.companyId, { expires: 30 });
        Cookies.set("phone", this.$route.params.phone, { expires: 30 });
      });
    },
    tabsChange(event) {
      console.log(event);
      // 重置公共查询参数页码
      this.queryParams.pageNum = 1;
      
      // 内部人员逻辑
      if (this.notAuthorized == 1) {
        if (event == 0) {
          // 切换到需求池
          this.finished = false;
          this.demandList = [];
          this.getAllDemand(1);
        } else {
          // 切换到工单
          this.orderfinished = false;
          this.orderList = [];
          this.getOrderFun(1);
        }
      } else {
        // 外部人员逻辑
        if (event == 0) {
          // 切换到需求池
          this.finished = false;
          this.demandList = [];
          this.getDemand(1);
        } else {
          // 切换到工单
          this.orderfinished = false;
          this.orderList = [];
          this.getOrderPhoneFun(1);
        }
      }
    },
    // 下拉刷新/加载更多统一入口
    onLoad() {
      this.loading = true;
      // 页码 +1
      this.queryParams.pageNum = this.queryParams.pageNum + 1;
      
      // 根据当前激活的 Tab 决定加载哪个列表
      if (this.active === 0) {
        // 需求池
        if (this.notAuthorized == 1) {
          this.getAllDemand();
        } else {
          this.getDemand();
        }
      } else {
        // 工单
        if (this.notAuthorized == 1) {
          this.getOrderFun();
        } else {
          this.getOrderPhoneFun();
        }
      }
    },
    getDemand(page) {
      // 如果是强制刷新（page=1），重置页码和列表
      if (page) {
        this.queryParams.pageNum = 1;
        this.demandList = [];
        this.finished = false;
      }
      
      // 确保 phone 参数正确
      this.queryParams.phone = this.$route.params.phone
        ? this.$route.params.phone
        : this.queryParams.phone;
        
      listDemand(this.queryParams).then((response) => {
        let rows = response.rows || [];
        rows.forEach((e) => {
          let className = "";
          if (e.status == 1) {
            className = "workOrder_top_content_box_top4";
          } else if (e.status == 2) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 3) {
            className = "workOrder_top_content_box_top2";
          } else if (e.status == 4) {
            className = "workOrder_top_content_box_top3";
          }
          e.class = className;
          const newti = this.delHtmlTag(e.content);
          this.$set(e, "newti", this.escape2Html(newti));
        });
        
        // 拼接数据
        this.demandList = this.demandList.concat(rows);
        this.loading = false;
        
        // 判断是否还有下一页
        const hasNextPage = response.total > this.demandList.length;
        this.finished = !hasNextPage;
      }).catch(() => {
        this.loading = false;
        this.finished = true;
      });
    },
    getAllDemand(page) {
      if (page) {
        this.queryParams.pageNum = 1;
        this.demandList = [];
        this.finished = false;
      }
      
      listDemandNo({
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        phone:  this.$route.params.phone ? this.$route.params.phone : this.queryParams.phone
      }).then((response) => {
        let rows = response.rows || [];
        rows.forEach((e) => {
          let className = "";
          if (e.status == 1) {
            className = "workOrder_top_content_box_top4";
          } else if (e.status == 2) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 3) {
            className = "workOrder_top_content_box_top2";
          } else if (e.status == 4) {
            className = "workOrder_top_content_box_top3";
          }
          e.class = className;
          const newti = this.delHtmlTag(e.content);
          e.newti = this.escape2Html(newti);
        });
        
        this.demandList = this.demandList.concat(rows);
        this.loading = false;
        
        const hasNextPage = response.total > this.demandList.length;
        this.finished = !hasNextPage;
      }).catch(() => {
        this.loading = false;
        this.finished = true;
      });
    },
    mineChange(e) {
      console.log(e, this.isMine);
      // 切换“我的”筛选时，重置工单列表
      this.queryParams.pageNum = 1;
      this.orderfinished = false;
      this.orderList = [];
      this.getOrderFun(1);
    },
    getOrderFun(page) {
      if (page) {
        this.queryParams.pageNum = 1;
        this.orderList = [];
        this.orderfinished = false;
      }
      
      this.loading = true;
      let data = {};
      if (this.isMine) {
        this.queryParams.phone = this.$route.params.phone ? this.$route.params.phone : this.queryParams.phone
        data = this.queryParams;
      } else {
        data = {
          pageNum: this.queryParams.pageNum,
          pageSize: this.queryParams.pageSize,
          phone:  this.$route.params.phone ? this.$route.params.phone : this.queryParams.phone
        };
      }
      
      listOrder(data).then((response) => {
        let rows = response.rows || [];
        rows.forEach((e) => {
          let className = "";
          if (e.status == 1) {
            className = "workOrder_top_content_box_top3";
          } else if (e.status == 2) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 3) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 4) {
            className = "workOrder_top_content_box_top2";
          } else if (e.status == 5) {
            className = "workOrder_top_content_box_top4";
          } else if (e.status == 6) {
            className = "workOrder_top_content_box_top5";
          }
          e.class = className;
        });
        
        this.orderList = this.orderList.concat(rows);
        this.loading = false;
        
        const hasNextPage = response.total > this.orderList.length;
        this.orderfinished = !hasNextPage;
      }).catch(() => {
        this.loading = false;
        this.orderfinished = true;
      });
    },
    getOrderPhoneFun(page) {
      if (page) {
        this.queryParams.pageNum = 1;
        this.orderList = [];
        this.orderfinished = false;
      }
      
      this.loading = true;
      if (this.isMine) {
        this.queryParams.isMe = 0;
      } else {
        this.queryParams.isMe = 1;
      }
      
      // 确保使用最新的 pageNum
      const requestData = {
        ...this.queryParams,
        pageNum: this.queryParams.pageNum
      };

      listOrderByPhone(requestData).then((response) => {
        let rows = response.rows || [];
        rows.forEach((e) => {
          let className = "";
          if (e.status == 1) {
            className = "workOrder_top_content_box_top3";
          } else if (e.status == 2) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 3) {
            className = "workOrder_top_content_box_top";
          } else if (e.status == 4) {
            className = "workOrder_top_content_box_top2";
          } else if (e.status == 5) {
            className = "workOrder_top_content_box_top4";
          } else if (e.status == 6) {
            className = "workOrder_top_content_box_top5";
          }
          e.class = className;
        });
        
        this.orderList = this.orderList.concat(rows);
        this.loading = false;
        
        const hasNextPage = response.total > this.orderList.length;
        this.orderfinished = !hasNextPage;
      }).catch(() => {
        this.loading = false;
        this.orderfinished = true;
      });
    },
    //跳转到公共页面
    gotoUrl(path) {
      console.log(window.__wxjs_environment);
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    goDetails(item) {
      var path = "/workOrderDetails/" + item.id;
      this.gotoUrl(path);
    },
    goTickets(item) {
      var path = "/ticketsDetails/" + item.id;
      this.gotoUrl(path);
    },
    handleAudit(row) {
      this.auditForm = row;
      this.title = "审核";
      this.auditShow = true;
    },
    goAddPage(id) {
      var path =
        "/workAddDemand/" +
        this.$route.params.companyId +
        "/" +
        this.$route.params.userId +
        "/" +
        this.queryParams.phone +
        "/" +
        id;
      this.gotoUrl(path);
    },
    goAddConvert(id) {
      var path =
        "/workAddConvert/" +
        this.$route.params.companyId +
        "/" +
        this.$route.params.userId +
        "/" +
        this.queryParams.phone +
        "/" +
        id;
      this.gotoUrl(path);
    },
    workAddOrder(item) {
      var path =
        "/workAddOrder/" +
        this.$route.params.companyId +
        "/" +
        this.$route.params.userId +
        "/" +
        this.queryParams.phone +
        "/" +
        item.id;
      this.gotoUrl(path);
    },
    upStatusFun(row) {
      this.form = row;
      const that = this;
      Dialog.confirm({
        title: "标题",
        message: "是否确认开始",
      })
        .then(() => {
          that.form.status = 1;
          updateOrder(this.form).then((response) => {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.queryParams.pageNum = 1;
            this.open = false;
            this.getOrderFun(1);
          });
        })
        .catch(() => {});
    },
    submitPhoneForm() {
      if (!this.form.phone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return;
      }
      getRoleByPhone({ phone: this.form.phone }).then((response) => {
        console.log(response);
        this.authType = response.msg;
        this.dialogVisible = false;
        if (this.authType == 0) {
          this.centerDialogVisible = true;
        } else {
          this.centerDialogVisible = false;
          this.queryParams.phone = this.form.phone;
          // 初始化加载需求列表
          this.getDemand(1);
        }
        Cookies.set("externalPhone", this.form.phone, { expires: 30 });
      });
    },
    submitauditForm() {
      this.auditForm.reviewerId = Cookies.get("userId");
      this.auditForm.reviewer = Cookies.get("NickName");
      updateDemand(this.auditForm).then((response) => {
        this.$message({
          message: "评审成功",
          type: "success",
        });
        this.auditShow = false;
        // 刷新列表
        if (this.notAuthorized == 1) {
           this.getAllDemand(1);
        } else {
           this.getDemand(1);
        }
      });
    },
    // 延期
    handlePostpone(row) {
      this.reset();
      this.form = row;
      this.$refs.workOrderPop.showForm(this.form, "填写延期原因");
    },
    handleUpdate(row) {
      this.form = row;
      this.$refs.workOrderPop.showForm(this.form, "修改工单基本信息");
    },
    /** 评审按钮操作 */
    handleReview(row) {
      Dialog.confirm({
        title: "标题",
        message: "是否确认工单已评审？",
      })
        .then(() => {
          row.status = 2;
          updateOrder(row).then((response) => {
            this.$message({
              message: "评审成功",
              type: "success",
            });
            this.queryParams.pageNum = 1;
            this.getOrderFun(1);
          });
        })
        .catch(() => {});
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        demandId: null,
        userId: null,
        userName: null,
        planStartTime: null,
        platEndTime: null,
        status: null,
        extensionMessage: null,
        files: null,
        wordFile: null,
        createTime: null,
      };
      this.resetForm("form");
    },
  },
};
</script>
<style scoped>
.workOrder {
  background-color: #f7f8fc;
}
.workOrder_top {
  background: linear-gradient(90deg, #66ccff, #3ba1f7);
  padding-top: 90px;
  position: relative;
}

.workOrder_top_content {
  background-color: #f7f8fc;
  border-radius: 20px 20px 0 0;
  width: 100%;
}

.workOrder_top_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.workOrder_top_box_tab {
  width: 90%;
  /* padding-bottom: 10px; */
  border-bottom: 1px solid #e8e8e8;
  padding-top: 6px;
}

.workOrder_top_content_box {
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  width: calc(100% - 40px);
  padding-bottom: 10px;
  border-radius: 8px;
}

.workOrder_top_content_box_top_i {
  margin-right: 5px;
  font-weight: 700;
}

.workOrder_top_content_box_top_span1 {
  font-weight: 700;
}

.workOrder_top_content_box_content {
  margin-top: 10px;
  padding: 0 15px;
}

.workOrder_top_content_box_content_title {
  font-size: 18px;
  font-weight: 700;
}

.workOrder_top_content_box_content_cell_title {
}

/* 发布小按钮 */
.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.btnBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin-bottom: 10px; */
  /* margin-top: 15px; */
  padding: 15px 15px 10px;
}

.workOrder_top_content_box_content_cell_title {
  color: #666666;
}

.cell_value {
  color: #333;
  font-weight: 700;
}

.cell_value2 {
  color: #3b87f7;
  font-weight: 500;
}

.cell_value3 {
  color: #ff8165;
  font-weight: 500;
}

.colorBoxBig {
  align-items: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
  display: flex;
  align-items: flex-start;
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 13px;
  border-radius: 3px;
}

.colorBoxBig {
  align-items: center;
}

.cell_value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style>
.workOrder .el-dialog--center .el-dialog__body {
  padding-top: 0 !important;
}

.workOrder .van-cell {
  padding: 10px 0 0;
}

.btnBox .van-button {
  margin-left: 10px;
  min-width: 70px;
}
.workOrder .van-tabs__nav {
  background-color: #f7f8fc;
}
.workOrder .van-tabs__line {
  width: 20px;
}
</style>